module.exports = __webpack_public_path__ + "img/1527036370.4dc3bd25.jpg";